"use strict";

exports.__esModule = true;
exports.TextureWrap = exports.TextureRegion = exports.TextureFilter = exports.Texture = exports.FakeTexture = void 0;

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
var Texture = /*#__PURE__*/function () {
  function Texture(image) {
    this._image = image;
  }

  var _proto = Texture.prototype;

  _proto.getImage = function getImage() {
    return this._image;
  };

  return Texture;
}();

exports.Texture = Texture;
var TextureFilter;
exports.TextureFilter = TextureFilter;

(function (TextureFilter) {
  TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
  TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
  TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
  TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
  TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
  TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
  TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear"; // WebGLRenderingContext.LINEAR_MIPMAP_LINEAR
})(TextureFilter || (exports.TextureFilter = TextureFilter = {}));

var TextureWrap;
exports.TextureWrap = TextureWrap;

(function (TextureWrap) {
  TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
  TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
  TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat"; // WebGLRenderingContext.REPEAT
})(TextureWrap || (exports.TextureWrap = TextureWrap = {}));

var TextureRegion = function TextureRegion() {
  this.u = 0;
  this.v = 0;
  this.u2 = 0;
  this.v2 = 0;
  this.width = 0;
  this.height = 0;
  this.degrees = 0;
  this.offsetX = 0;
  this.offsetY = 0;
  this.originalWidth = 0;
  this.originalHeight = 0;
};

exports.TextureRegion = TextureRegion;

var FakeTexture = /*#__PURE__*/function (_Texture) {
  _inheritsLoose(FakeTexture, _Texture);

  function FakeTexture() {
    return _Texture.apply(this, arguments) || this;
  }

  var _proto2 = FakeTexture.prototype;

  _proto2.setFilters = function setFilters(minFilter, magFilter) {};

  _proto2.setWraps = function setWraps(uWrap, vWrap) {};

  _proto2.dispose = function dispose() {};

  return FakeTexture;
}(Texture);

exports.FakeTexture = FakeTexture;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUE2QnNCQSxPO0VBR3JCLGlCQUFhQyxLQUFiLEVBQWtEO0lBQ2pELEtBQUtDLE1BQUwsR0FBY0QsS0FBZDtFQUNBOzs7O1NBRURFLFEsR0FBQSxvQkFBUTtJQUNQLE9BQU8sS0FBS0QsTUFBWjtFQUNBLEM7Ozs7OztBQU9GLElBQVlFLGFBQVo7OztBQUFBLFdBQVlBLGFBQVosRUFBeUI7RUFDeEJBO0VBQ0FBO0VBQ0FBO0VBQ0FBO0VBQ0FBO0VBQ0FBO0VBQ0FBLGlGQVB3QixDQU9FO0FBQzFCLENBUkQsRUFBWUEsYUFBYSw2QkFBYkEsYUFBYSxNQUF6Qjs7QUFVQSxJQUFZQyxXQUFaOzs7QUFBQSxXQUFZQSxXQUFaLEVBQXVCO0VBQ3RCQTtFQUNBQTtFQUNBQSxzREFIc0IsQ0FHUDtBQUNmLENBSkQsRUFBWUEsV0FBVywyQkFBWEEsV0FBVyxNQUF2Qjs7SUFNYUMsYSxHQUFiO0VBRUMsU0FBSSxDQUFKO0VBQU8sU0FBSSxDQUFKO0VBQ1AsVUFBSyxDQUFMO0VBQVEsVUFBSyxDQUFMO0VBQ1IsYUFBUSxDQUFSO0VBQVcsY0FBUyxDQUFUO0VBQ1gsZUFBVSxDQUFWO0VBQ0EsZUFBVSxDQUFWO0VBQWEsZUFBVSxDQUFWO0VBQ2IscUJBQWdCLENBQWhCO0VBQW1CLHNCQUFpQixDQUFqQjtBQUNuQixDOzs7O0lBRVlDLFc7Ozs7Ozs7OztVQUNaQyxVLEdBQUEsb0JBQVlDLFNBQVosRUFBc0NDLFNBQXRDLEVBQThELENBQUssQzs7VUFDbkVDLFEsR0FBQSxrQkFBVUMsS0FBVixFQUE4QkMsS0FBOUIsRUFBZ0QsQ0FBSyxDOztVQUNyREMsTyxHQUFBLG1CQUFPLENBQU8sQzs7O0VBSGtCZCxPIiwibmFtZXMiOlsiVGV4dHVyZSIsImltYWdlIiwiX2ltYWdlIiwiZ2V0SW1hZ2UiLCJUZXh0dXJlRmlsdGVyIiwiVGV4dHVyZVdyYXAiLCJUZXh0dXJlUmVnaW9uIiwiRmFrZVRleHR1cmUiLCJzZXRGaWx0ZXJzIiwibWluRmlsdGVyIiwibWFnRmlsdGVyIiwic2V0V3JhcHMiLCJ1V3JhcCIsInZXcmFwIiwiZGlzcG9zZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvVGV4dHVyZS50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==